import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';


@Component({
  selector: 'app-model-detaile',
  templateUrl: './model-detaile.component.html',
  styleUrls: ['./model-detaile.component.scss']
})
export class ModelDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public site: string = this.serverService.get_site();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public type_task: number | undefined;
  public form1_group: FormGroup | any;
  public user_id: number | any;
  public id: number | undefined;
  public i: number | undefined;
  public code: number | undefined;
  public title: string | undefined;
  public search_array: any = [];
  public creator: number | undefined;
  public expire: boolean | undefined;
  public access_service: number | undefined;
  public level: number | undefined;

  constructor(
    public serverService: ServerService
    , public router: Router
    , public messageService: MessageService
    , public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any
    , public dialog: MatDialog
    , public matDialogRef: MatDialogRef<ModelDetaileComponent>) {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        if (this.dialog_data) this.creator = this.dialog_data.creator;
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          comment: dialog_data.search_array.comment,
          device_title: dialog_data.search_array.device_title,
          device: dialog_data.search_array.device,
          brand_title: dialog_data.search_array.brand_title,
          brand: dialog_data.search_array.brand,
          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'device_title': new FormControl(null),
      'device': new FormControl(null),
      'brand_title': new FormControl(null),
      'brand': new FormControl(null),
      'title': new FormControl(null),
      'comment': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['device'].setValidators([Validators.required]);
      this.form1_group.controls['brand'].setValidators([Validators.required]);
      this.form1_group.controls['status_id'].setValidators([Validators.required]);
    }

  }

  check_access(type_task: any, excel: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code, lang: this.lang }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.title = res['result'][0].title;
          this.check_access2(type_task, excel, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }


  check_access2(type_task: any, excel: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.expire = res['expire'];
          this.loading = false;
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            } else {
              this.insert();
            }
          }
          if (type_task == 2) { this.update(); }
          if (type_task == 3) { this.search(excel); }
          if (type_task == 4) { this.get_data(); }
          if (type_task == 5) { this.get_status(); }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      comment: this.form1_group.value.comment,
      device_title: this.form1_group.value.device_title,
      device: this.form1_group.value.device,
      brand_title: this.form1_group.value.brand_title,
      brand: this.form1_group.value.brand,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      export_excel: excel
    })
  }

  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1675, id: this.id, lang: this.lang }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].repairman_model_title,
            'device_title': res['result'][0].wharehouse_device_title,
            'device': res['result'][0].repairman_model_device,
            'brand_title': res['result'][0].repairman_brand_title,
            'brand': res['result'][0].repairman_model_brand,
            'comment': res['result'][0].repairman_model_comment,
            'sort': res['result'][0].repairman_model_sort,
            'status_id': res['result'][0].repairman_model_status,
            'status_title': res['result'][0].status_title,
          }
          )
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }

  insert() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1671, "user_id": this.user_id
      , 'status_id': this.form1_group.value.status_id
      , 'title': this.form1_group.value.title
      , 'device': this.form1_group.value.device
      , 'brand': this.form1_group.value.brand
      , 'comment': this.form1_group.value.comment
      , 'sort': this.form1_group.value.sort
      , 'creator': this.creator
      , 'lang': this.lang
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "نام مدل در هر نوع دستگاه و برند  مي بايست منحصر به فرد باشد";
          var en_message = "The model name must be unique in every type of device and brand";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end insert

  update() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1672, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'device': this.form1_group.value.device
      , 'brand': this.form1_group.value.brand
      , 'comment': this.form1_group.value.comment
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'creator': this.creator
      , 'lang': this.lang
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          )
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "نام مدل در هر نوع دستگاه و برند  مي بايست منحصر به فرد باشد";
          var en_message = "The model name must be unique in every type of device and brand";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update

  check_letter(event): any {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 && charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
    }
  }

  get_status() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1, lang: this.lang }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }


  load_services(id: number) {
    var code_id;
    if (id == 164) {
      code_id = 6718;
      if (!this.form1_group.value.device) {
        var pe_message = " لطفا در ابتدا دستگاه را انتخاب کنید";
        var en_message = "Please select the device first";
        this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        return false;
      }

    }

    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        id: id, creator: this.creator, code_id: code_id, obj: {
          device: this.form1_group.value.device
        }
      }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 154) {
            this.form1_group.patchValue({
              'device': res.id,
              'device_title': res.title,
              'brand': null,
              'brand_title': null
            })
          }
          if (id == 164) {
            this.form1_group.patchValue({
              'brand': res.id,
              'brand_title': res.title
            })
          }
        }
      }
    )

  }


  reset_input(id: number) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 154) {
      this.form1_group.patchValue({
        'device': null,
        'device_title': null,
        'brand': null,
        'brand_title': null
      })
    }
    if (id == 164) {
      this.form1_group.patchValue({
        'brand': null,
        'brand_title': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) { this.loading = false; }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
